import * as ko from "knockout";
import { BaseViewModel, HttpAction, CustomWindow, IBaseViewModel } from "./baseviewmodel";
import { KnockoutExtensions } from "../KnockoutExtensions/knockoutextensions";
import { DialogViewModel, DialogAction } from "./dialogviewmodel";
import "../Templates/session-expiry-dialog-content.html";
import { LoginResponse } from "../Models/loginresponse";

class SessionViewModel extends BaseViewModel {

    constructor() {
        super(null);

        (window as CustomWindow).viewModels = new Array<IBaseViewModel>();

        // Add base timer for 1 miniute
        var self = this;
        var timer = setInterval(function () {
            if (self.readSetting("isLoggedIn") !== null && self.readSetting("isLoggedIn") == "1") {
                var lastAccessed = new Date(localStorage.getItem("lastAccessed"));
                var nowDate = new Date();
                var diff = new Date(nowDate.getTime() - lastAccessed.getTime());
                if (diff.getMinutes() >= 15) {
                    self.sessionExpired();
                }
                if (diff.getMinutes() >= 1) {
                    self.checkSession(self);
                }
            }
        }, 30000);
    }

    public checkSession(self: SessionViewModel) {
        if (self.readSetting("isLoggedIn") !== null && self.readSetting("isLoggedIn") == "1") {
            self.postJsonData("/api/account/heartbeat", null, function () {
                // Success so continue 
            },
                function (err, status, xhr) {
                    if (err.status == 401) {
                        // Error so check if 401
                        event.stopPropagation();
                        self.writeSetting("isLoggedIn", "0");
                        self.signOut(self);
                    }
                });
        }
    }

    public signOut(self: SessionViewModel) {
        self.postJsonData("/api/account/logout", null, function () {
            // Success so continue 
            self.writeSetting("isLoggedIn", "0");
            self.canAccess(false);
            //self.navigateHome();
        }, function () {
            // Error so assume authentication issue and request signin 
            self.writeSetting("isLoggedIn", "0");
            self.canAccess(false);
            //self.navigateHome();
        });
    }

    public getPersistenceIncludedProperties(): string[] { return []; }

    public getPersistenceIgnoredProperties(): string[] {
        return super.getPersistenceIgnoredProperties().concat(["canAccess"]);
    }

    public init() {
        this.canAccess(false);
        ko.applyBindings(this, $('#main-layout')[0]);

        (window as CustomWindow).sessionState = this;
    }

    public showActionButton() {
    }

    public sessionExpired() {
        var username = this.readSetting("nutricalc-login");
        if (!this.isSessionExpired()) {
            this.isSessionExpired(true);
            this.canAccess(false);
            $('.sessionexpired-overlay').show();
            var dialog = new SessionexpiryDialogViewModel(this);
            this.showDialog(dialog);
            $('#dialog-session-expiry').attr('style', 'z-index: 999999;');
        }
    }
}

class SessionexpiryDialogViewModel
    extends DialogViewModel {

    public password = ko.observableArray<string>(null);

    constructor(public viewModel: BaseViewModel) {
        super("session-expiry",
            "Your session has expired",
            KnockoutExtensions.getTemplateByName("session-expiry-dialog-content"),
            [
                new DialogAction("Sign In", () => {
                    this.isBusy(true);
                    var username = viewModel.readSetting("nutricalc-login");
                    viewModel.postJsonData("/api/account/login", { email: username, password: this.password(), returnUrl: "" }, (response: LoginResponse) => {
                        if (response.isSuccess) {
                            viewModel.writeSetting("isLoggedIn", "1");
                            $('.sessionexpired-overlay').hide();
                            viewModel.isSessionExpired(false);
                            viewModel.canAccess(true);
                            this.isBusy(false);
                        } else {
                            this.isBusy(false);
                        }
                    }, () => this.isBusy(false));
                    return false;
                }, true)
            ]);
    }
}

export { SessionViewModel, SessionexpiryDialogViewModel };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/ViewModels/sessionviewmodel.ts